export let TrailerGenerationErrorType = /*#__PURE__*/function (TrailerGenerationErrorType) {
  TrailerGenerationErrorType["InternalError"] = "internal_error";
  TrailerGenerationErrorType["ConnectivityIssue"] = "connectivity_issue";
  return TrailerGenerationErrorType;
}({});
//# sourceMappingURL=trailer-generation-statuses.js.map